import { useMemo } from 'react';
import { Share, SharesTitle } from 'types';
import i18n from 'i18n/config';

import { getShareTitleWatermarkText } from 'utils/getShareTitleWatermarkText';
import {
  generateSharesTitlesFilename,
  generateSharesTitlesFilenameWithCoOwners,
} from 'modules/partners/utils/generateSharesTitlesFilename';

import { getTitleByShare } from '../utils/getTileByShare';

type UseGetShareTitleDataProps = {
  share: Share;
  sharesTitles: SharesTitle[];
  isAdmin: boolean;
};

export const useGetShareTitleData = ({
  share,
  sharesTitles,
  isAdmin,
}: UseGetShareTitleDataProps) =>
  useMemo(() => {
    const shareTitle = getTitleByShare(sharesTitles, share);

    if (!shareTitle) {
      return {
        data: {
          shareTitleId: '',
          titleWatermarkText: '',
          titleNumber: '',
        },
      };
    }

    const titleNumber = shareTitle?.number;
    const titleEncumbranceNumber =
      shareTitle?.encumbranceNumber || shareTitle?.number;
    const titleWatermarkText = getShareTitleWatermarkText({
      status: shareTitle?.status,
      isAdmin,
    });
    const titleName = generateSharesTitlesFilename({
      sharesTitle: shareTitle,
      t: i18n.t,
    });
    const titleCoOwnerName = generateSharesTitlesFilenameWithCoOwners({
      sharesTitle: shareTitle,
      t: i18n.t,
    });

    return {
      data: {
        titleId: shareTitle?._id || '',
        titleWatermarkText,
        titleNumber,
        titleName,
        titleCoOwnerName,
        titleEncumbranceNumber,
      },
    };
  }, [sharesTitles, share, isAdmin]);
